module.exports = __webpack_public_path__ + "static/fonts/hiragino-kaku-gothic-pron-w6.21a3b00.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hiragino-kaku-gothic-pron-w6.otf
// module id = T9rY
// module chunks = 41